import { nanoid } from "nanoid";

import { TUserAuthData } from "@storage/session/types";
import { userAuthDataStorage } from "@storage/sessionStorage";

export const reconnectWs = (roomChatId: string) => {
	const currentAccount = userAuthDataStorage.getItemAsJson<TUserAuthData>();
	if (!currentAccount?.chatClientId) {
		return;
	}

	return {
		type: "connectToRoomChat",
		correlationId: nanoid(),
		payload: {
			clientId: currentAccount.chatClientId,
			isModel: true,
			roomChatId: roomChatId,
		},
	};
};
